{
  "title": "Summon Draconic Spirit",
  "source": "Fizban's Treasury of Dragons",
  "levelAndSchool": "5th-level Conjuration",
  "level": 5,
  "castingTime": "1 Action",
  "range": "60ft",
  "components": "V, S, M (an object with the image of a dragon engraved on it, worth at least 500 gp)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You call forth a draconic spirit. It manifests in an unoccupied space that you can see within range. This corporeal form uses the Draconic Spirit stat block. When you cast this spell, choose a family of dragon: chromatic, gem, or metallic. The creature resembles a dragon of the chosen family, which determines certain traits in its stat block. The creature disappears when it drops to 0 hit points or when the spell ends.",
    "The creature is an ally to you and your companions. In combat, the creature shares your initiative count, but it takes its turn immediately after yours. It obeys your verbal commands (no action required by you). If you don’t issue any, it takes the Dodge action and uses its move to avoid danger.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th level or higher, use the higher level wherever the spell’s level appears in the stat block.",
    "Draconic Spirit",
    "Large Dragon, Neutral",
    "Armor Class 14 + the level of the spell (natural armor)",
    "Hit Points 50 + 10 for each spell level above 5th (the dragon has a number of hit dice [d10s] equal to the level of the spell)",
    "Speed 30 ft., fly 60 ft., swim 30 ft.",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "19 (+4)",
    "14 (+2)",
    "17 (+3)",
    "10 (+0)",
    "14 (+2)",
    "14 (+2)",
    "Damage Resistances(Chromatic and Metallic Only) acid, cold, fire, lightning, poison",
    "Damage Resistances(Gem Only) force, necrotic, psychic, radiant, thunder",
    "Condition Immunities charmed, frightened, poisoned",
    "Senses blindsight 30 ft., darkvision 60 ft., passive Perception 12",
    "Languages Draconic, understands the languages you speak",
    "Challenge — Proficiency Bonus (PB) equals your bonus",
    "Shared Resistances. When you summon the dragon, choose one of its damage resistances. You have resistance to the chosen damage type until the spell ends",
    "Actions",
    "Multiattack. The dragon makes a number of Rend attacks equal to half the spell’s level (rounded down), and it uses Breath Weapon.",
    "Rend. Melee Weapon Attack: your spell attack modifier to hit, reach 10 ft., one target. Hit: 1d6 plus 4 + the spell's level piercing damage.",
    "Breath Weapon. The dragon exhales destructive energy in a 30-foot cone. Each creature in that area must make a Dexterity saving throw against your spell save DC. A creature takes 2d6 damage of a type this dragon has resistance to (your choice) on a failed save, or half as much damage on a successful one."
  ],
  "spellLists": ["druid", "sorcerer", "wizard"]
}
